import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { defineStyles, theme } from '../theme';
import { useSTRowFilterCondition } from '../table';
import MaxRecordsCustomCountForm from './MaxRecordsCustomCountForm';
import { paginationOptions } from './constants';
const styles = defineStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        borderRadius: 1,
        boxSize: 'border-box',
        border: `1px solid ${theme.vars.palette.border.main}`,
        width: 'fit-content',
        p: '3px 9px',
    },
    label: {
        fontSize: '0.8125rem',
        color: theme.vars.palette.text.secondary,
    },
    select: {
        color: theme.vars.palette.text.primary,
        fontWeight: 'bold',
        height: '24px',
        '& .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 0,
        },
        '& .MuiSelect-select': {
            padding: 0,
            fontSize: '0.8125rem',
        },
        '& .MuiSelect-icon': {
            right: 0,
        },
    },
    menuItem: {
        fontSize: '0.8125rem',
        color: theme.vars.palette.text.primary,
    },
});
const MaxRecordsCustomSectionCore = ({ sx }) => {
    const [condition, setCondition] = useSTRowFilterCondition();
    const [paginationValue, setPaginationValue] = useState(() => {
        if (!condition?.maxRecords)
            return 'All';
        if (paginationOptions.includes(condition.maxRecords))
            return condition.maxRecords;
        return 'Custom';
    });
    const handleResetClick = () => {
        setPaginationValue('All');
        setCondition((prev) => ({ ...(prev ?? { andConditions: [] }), maxRecords: null }));
    };
    const handleChange = (value) => {
        setPaginationValue(value);
        if (value === 'Custom') {
            return;
        }
        if (value === 'All') {
            setCondition((prev) => ({ ...(prev ?? { andConditions: [] }), maxRecords: null }));
            return;
        }
        setCondition((prev) => ({ ...(prev ?? { andConditions: [] }), maxRecords: value }));
    };
    return (_jsxs(Box, { sx: { ...styles.root, ...sx }, children: [_jsx(InputLabel, { id: "max-record-select", sx: styles.label, children: _jsx(FormattedMessage, { id: "maxRecords.select.label", defaultMessage: "Max records:" }) }), _jsx(Select, { id: "max-record-select", size: "small", value: paginationValue, onChange: (e) => handleChange(e.target.value), sx: styles.select, children: paginationOptions.map((value) => (_jsx(MenuItem, { dense: true, value: value, children: value }, value))) }), paginationValue === 'Custom' && _jsx(MaxRecordsCustomCountForm, { onResetClick: handleResetClick })] }));
};
export default MaxRecordsCustomSectionCore;
//# sourceMappingURL=MaxRecordsCustomSectionCore.js.map